export default function Footer() {
  return (
    <footer className="py-5">
      <p className="text-center text-gray-600">© Muhamad Danendra Prawiraamijoyo</p>
    </footer>
  );
}
